export default __webpack_public_path__ + "img/referral-icon-afc5d36fa3bd87bd0be972a03d508a0e.png";